import { useEffect, useState } from "react";
import { lddGlobalSessionInfo } from "../../navigationTypes";
import { useAppSelector } from "../../../redux/hooks";
import { lddStateObject } from "../../../redux/reducer";
import { getDataReader } from "../../../livedataFuncs";
import { BuilderStateType } from "../BuilderDoc/types";
import { DRImport } from "./DRImport";
import './DRImport.css'
import BuilderBanner from "../BuilderBanner";
import Loading from "../../Loading";
import { isPageInDrPasscodeFile, loginWithPassCode } from "../../../dr/Components/drFuncs";

export const BuilderConnectInfo = () => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const currentPage = useAppSelector((state: lddStateObject) => state.currentNavigation?.page);
    const sessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const [builderState, setBuilderState] = useState<BuilderStateType>({appId: null, appCode: null, msgID: null});
    const [drDataRoot, setDrDataRoot] = useState(null);
    useEffect(() => {
        let id: string, appCode: string, msgID: string;
        if (livedataRootContainer?.dataRoot) {
            const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
            id = DataReaderObj.getAppId();
            appCode = DataReaderObj.getAppCode();
            msgID = DataReaderObj.getVIPInfoMsgID();
            setBuilderState({appId: id, appCode: appCode, msgID: msgID});
        }
    }, [livedataRootContainer.dataRoot])

    useEffect(() => {
        const fetchData = async () => {
            if (builderState.msgID) {
                const DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
                const passCode = DataReaderObj.getVIPInfoPassCode();
                if (passCode) {
                    await loginWithPassCode(passCode);
                }
                let url: string;
                if (isPageInDrPasscodeFile(currentPage) || passCode) {
                    url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/passcode/msgxml?PassCode=1&MsgID=${builderState.msgID}`;
                } else {
                    url = `${process.env.REACT_APP_DSAPI_ENDPOINT}/dr/${sessionInfo.firm.id}/${sessionInfo.user.account}/msgxml?MsgID=${builderState.msgID}&SessionID=${sessionInfo.sid}`;
                }
                fetch(url).then((response) => {
                    response.text().then((textData) => {
                        let xmlDom = new ajaxslt.XDocument();
                        xmlDom.loadXML(textData);
                        let doc = xmlDom.documentElement;
                        if (doc.nodeName === 'Root' && doc.firstChild.nodeName === 'TPAppXML') {
                            // append VIPInfo to TPAppXML
                            doc.firstChild.appendChild(doc.selectSingleNode("VIPInfo"));
                            doc = doc.firstChild;
                        }
                        if (doc.nodeName === 'TPAppXML') {
                            setDrDataRoot(doc as any);
                        }
                    })
                })
            } else {
                setDrDataRoot(null);
            }
        };

        fetchData();
    }, [builderState.msgID])
    
    return <>
        <BuilderBanner sessionInfo={sessionInfo} msgID={builderState.msgID} drDataRoot={drDataRoot} showImport={true} />
        {drDataRoot ? <DRImport drDataRoot={drDataRoot}/> : <Loading showMsg extraMsg={'Loading NewHomeConnect'} />}
    </>
}